module.exports = __webpack_public_path__ + "img/exchange.63b178c3.svg";